import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { retry, catchError, map, of, timer } from 'rxjs';
import { SessionService } from '../services/session.service';
import { ClientCookiesService } from '../services/client-cookies.service';

export const sessionResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const sessionService = inject(SessionService);
  const clientCookiesService = inject(ClientCookiesService);

  let fullURL = '';
  let referrerURL = '';

  if (typeof window !== 'undefined') {
    const parsedUrl = new URL(window.location.href);
    fullURL = encodeURIComponent(decodeURI(parsedUrl.href));
    referrerURL = encodeURIComponent(decodeURI(document.referrer || ''));
  }

  if (typeof window === 'undefined') {
    console.warn('SSR detected, skipping session generation');
    return of({ error: 'SSR mode, session skipped' });
  }

  return sessionService.generateSession(fullURL, referrerURL).pipe(
    retry({
      count: 2,  // Retry 3 times
      delay: (error, retryCount) => {
        console.log(`Attempt ${retryCount}: retrying in ${Math.pow(2, retryCount)}s`);
        return timer(Math.pow(2, retryCount) * 1000);  // 1s, 2s, 4s
      }
    }),
    map((response) => {
      if (response && response['session-uuid']) {
        sessionService.saveSessionToLocalStorage(response);        
        //clientCookiesService.collectAndUpdateCookies();     
        return response;
      } else {
        console.error('Invalid session response:', response);
        return { error: 'Invalid session response' };
      }
    }),
    catchError((error) => {
      console.error('Session generation failed:', JSON.stringify(error));
      return of({ error: 'failed' });
    })
  );
};